<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%;" />
    <div slot="menu" class="menucontextual">

      <button class="pure-button btnHNA ripple" @click.prevent="openAreaClienteSaludHna()">
        Gestiona tu póliza
      </button>

      <SeccionOcultable titulo="Documentación">
        <ul>
          <li>
            <a class="enlace"
              href="https://www.mmtseguros.com/hubfs/Informacion_Corporativa/Estatutos-Sociales-2025.pdf?hsLang=es-es"
              target="_blank">Estatutos sociales</a>
          </li>
        </ul>
      </SeccionOcultable>
    </div>

    <div v-if="poliza" slot="contenido" class="tarjetario">
      <Tomador :poliza="poliza" />
      <ContratoSalud :poliza="poliza" />
      <DatosBancariosSalud :poliza="poliza" />
      <Asegurados :asegurados="poliza.asegurados" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {

    };
  },
  computed: {
    poliza() {
      return this.$store.state.seleccion;
    },

    titulo() {
      return "Póliza: " + this.poliza.nsg("numPoliza");
    },

    idCliente() {
      return this.$store.state.portfolio.idCliente
    }

  },

  beforeRouteEnter: async function (to, from, next) {
    await fetchData(to.params.numPoliza);
    next();
  },

  beforeRouteUpdate: async function (to, from, next) {
    await fetchData(to.params.numPoliza);
    next();
  },

  methods: {
    openAreaClienteSaludHna() {
      this.$store.dispatch("openAreaClienteSaludHna", this.idCliente);
    },
  },
};

import store from "@/store/store.js";
async function fetchData(numPoliza) {
  await store.dispatch("getPolizaSalud", numPoliza);
}
</script>

<style lang="scss" scoped>
.linkTituloSeccion {
  text-decoration: none;

  :hover {
    text-decoration: none;
    cursor: pointer;
  }

  :active {
    text-decoration: none;
    cursor: pointer;
  }
}

.tituloSeccion {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
}

.tituloSeccionBlinker {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.noDisponibleCCPP {
  font-size: 85%;
  color: cyan;
}

.btnHNA {
  background-color: $naranjaMMT;
  font-size: 120%;
  color: white;
  width: 100%;
}
</style>
